function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M948.4,917.2V231.9v-62.4v-7.6h-0.2C944.2,72.3,870,0.6,779.4,0.6S614.7,72.3,610.7,161.9h-0.2v7.6v62.4v107.9H161.8   l-61.6,192.2v375.6c-33.6,7.7-67,16.3-100.2,26v73C162.9,957.3,333.4,932,504,932c170.6,0,341.1,25.3,504,74.4v-73   C988.2,927.7,968.3,922.3,948.4,917.2z M779.4,70.6c52,0,94.8,40.3,98.6,91.4H680.8C684.7,110.9,727.4,70.6,779.4,70.6z    M212.9,409.8h494.9l29.7,92.6H183.2L212.9,409.8z M517.4,862c-4.5,0-8.9-0.1-13.4-0.1c-33.6,0-67.2,0.9-100.7,2.8V685.9h114.1V862   z M750.4,878.8c-54-7.4-108.4-12.4-163-14.9v-248H333.3V870c-54.7,5.2-109.1,12.8-163,22.9V572.4h580.2V878.8z M878.4,901   c-19.2-4.1-38.6-7.8-57.9-11.2V531.9l-61.6-192.2h-78.3V231.9h197.9V901z"
}));

function SvgFarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1008 1008",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/farm.5085e88d.svg";
export { ForwardRef as ReactComponent };